import React, { createContext, useContext } from "react";
import { Link } from "react-router-dom";
import Media from "react-media";
import { MobileMenu } from "./MobileMenu";
import "./north.css";
import { UserPersona } from "./UserPersona";
import { HomeOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { AssetContext } from "../AssetContext";
import MainStore from "../../store/mainStore";
import { observer } from "mobx-react-lite";
import { ApplicationPreference } from "./ApplicationPreference";
const mainstore = createContext(MainStore);
export const North = observer((props) => {
  const mainStore = useContext(mainstore);
  const handleClearSelection = () => {
    props.clearselection();
  };

  const menuClick = (menu) => {
    props.clearselection();
    console.log(menu); //this menu id is the menu id of the parent menu coming from the database
    switch (menu.menuId) {
      case 2:
        mainStore.showProductionManagementGlobalLinkDialog = true;
        break;
      case 9:
        mainStore.showTechnicalGlobalLinkDialog = true;
        break;
      default:
        break;
    }

    // this.props.commonStore.setUserLastVisitedUrl(menu.menuUrl);
  };
  return (
    <div className="ms-Grid home-top-menu" dir="ltr">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm1 home">
          {" "}
          <Tooltip title="Switch Asset Context to NAOC Asset,EBENDO Asset or QUA IBO Asset ">
            <Button
              type="link"
              icon={
                <HomeOutlined style={{ color: "white", fontSize: "30px" }} />
              }
              onClick={() => {
                mainStore.showContextDialog = true;
              }}
            ></Button>
          </Tooltip>
        </div>
        <div className="ms-Grid-col ms-sm8 ">
          <Media query={{ minWidth: 1024 }}>
            {(matches) =>
              matches ? (
                <nav
                  className="top-menu-nav"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ul className="top-menu-ul">
                    {props.menu.map((menu, idx) => (
                      <li className="to-link-item" key={idx}>
                        <Link
                          to="#"
                          onClick={(ev) => {
                            menuClick(menu);
                          }}
                        >
                          <span>{menu.menu}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </nav>
              ) : (
                <div id="mobile-menu-container">
                  <div className="mobile-nav">
                    <MobileMenu
                      menus={props.menu}
                      clearselection={handleClearSelection}
                    />
                  </div>
                </div>
              )
            }
          </Media>
        </div>

        <UserPersona shownotofication={true} history={props.history} />
        <AssetContext />
        <ApplicationPreference />
      </div>
    </div>
  );
});

